export const OUTVIEW_CLASSNAME = 'is-outview';
export const INVIEW_CLASSNAME = 'is-inview';
export const INVIEW_ENTER = 'enter';
export const INVIEW_EXIT = 'exit';

export const DIRECTION_DOWN = 'down';
export const DIRECTION_UP = 'up';
export const DIRECTION_DOWN_CLASSNAME = "--js-scroll-down";
export const DIRECTION_UP_CLASSNAME = "--js-scroll-up";

export const SCROLL_MINIMUM = 50;
export const SCROLL_MINIMUM_CLASSNAME = "--js-scroll-min";
export const SCROLLBAR_HIDDEN_CLASSNAME = "--js-scrollbar-hidden";

export const SCROLL_TO_OPTIONS = {
  offset: 0,
  smooth: true,
  callback: false,
  duration: null,
  easing: 'linear',
};

export default {
  OUTVIEW_CLASSNAME,
  INVIEW_CLASSNAME,
  INVIEW_ENTER,
  INVIEW_EXIT,
  DIRECTION_DOWN,
  DIRECTION_UP,
  DIRECTION_DOWN_CLASSNAME,
  DIRECTION_UP_CLASSNAME,
  SCROLL_MINIMUM,
  SCROLL_MINIMUM_CLASSNAME,
  SCROLLBAR_HIDDEN_CLASSNAME,
  SCROLL_TO_OPTIONS,
};
